module.exports = __webpack_public_path__ + "img/InterestsAndFollowUps.44d7ec69.svg";